module.exports = __webpack_public_path__ + "img/listen.88bb46a1.png";